import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {gsap} from "gsap";
import {isMobile, isTablet} from "../helpers";

export function observeVideo() {
    const $blocks = $('.our-works-block-inner');
    gsap.registerPlugin(ScrollTrigger);

    if (!$blocks.length) return;

    ScrollTrigger.saveStyles('.mobile, .desktop');

    ScrollTrigger.matchMedia({
        "(min-width: 300px)": function () {
            for (let i = 0; i < $blocks.length; i++) {
                const videos = $($blocks[i]).find('video');

                const itemTimeLine = gsap.timeline({
                    scrollTrigger: {
                        trigger: $blocks[i],
                        scroller: isMobile() || isTablet() ? '' : '.scroller',
                        // scroller: ".scroller",
                        start: 'top center',
                        scrub: true,
                        onEnter: () => {
                            if (videos.length) {
                                playVideos(videos)
                            }
                        },
                        onEnterBack: () => {
                            if (videos.length) {
                                playVideos(videos)
                            }
                        },
                        onLeave: () => {
                            if (videos.length) {
                                pauseVideos(videos)
                            }
                        },
                        onLeaveBack: () => {
                            if (videos.length) {
                                pauseVideos(videos)
                            }
                        }
                    }
                })
            }
        }
    });

    function playVideos(videos) {
        for (let i = 0; i < videos.length; i++) {
            videos[i].play();
        }
    }

    function pauseVideos(videos) {
        for (let i = 0; i < videos.length; i++) {
            videos[i].pause();
        }
    }
}

export function resizeVideo() {
    let windowWidth = $(window).width();
    let windowHeight = window.innerHeight;

    //масштибирование видео
    if ($("#main_video").length) {
        const kHW = 0.5625;
        const kWH = 1.9;
        const kWindow = windowHeight / windowWidth;

        let widthVideo = windowHeight * kWH;
        let heightVideo = windowHeight;

        if (kWindow < kHW) {
            widthVideo = windowWidth;
            heightVideo = windowWidth * kHW;
        }

        $("#main_video").css({
            width: widthVideo + "px",
            height: heightVideo + "px",
            transform: `translate(${-widthVideo / 2}px, ${-heightVideo / 2}px)`
        });
    }
}

export function updateViewportHeight() {
    if ($(document).width() < 1000) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    } else {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
}
